import { Zap, CalendarDays, CalendarRange, Compass } from "lucide-react";
import { OptionCard } from "./OptionCard";

const TIMELINES = [
  { key: "ASAP", icon: Zap, id: "asap" },
  { key: "Within 1 month", icon: CalendarDays, id: "1month" },
  { key: "1-3 months", icon: CalendarRange, id: "3months" },
  { key: "Just exploring", icon: Compass, id: "exploring" },
];

export const TimelineStep = ({ value, onChange }) => (
  <div className="grid gap-3">
    {TIMELINES.map((t) => (
      <OptionCard key={t.key} title={t.key} icon={t.icon} selected={value === t.key}
        onClick={() => onChange(t.key)} testId={`timeline-option-${t.id}`} />
    ))}
  </div>
);
